module.exports = __webpack_public_path__ + "img/spin_btn.c424ba7e.png";